module.exports = __webpack_public_path__ + "img/1.13db5d99.png";